import { render, staticRenderFns } from "./PrintPreviewAppDetailHeader.vue?vue&type=template&id=b36eed00&scoped=true"
import script from "./PrintPreviewAppDetailHeader.vue?vue&type=script&lang=js"
export * from "./PrintPreviewAppDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36eed00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b36eed00')) {
      api.createRecord('b36eed00', component.options)
    } else {
      api.reload('b36eed00', component.options)
    }
    module.hot.accept("./PrintPreviewAppDetailHeader.vue?vue&type=template&id=b36eed00&scoped=true", function () {
      api.rerender('b36eed00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/printpreview/PrintPreviewAppDetailHeader.vue"
export default component.exports